import React from 'react';
import isNumber from 'is-number';
import { insertImages } from '../../../markup/commands';
import { IMG_MAX_HEIGHT } from '../../cm-upload/const';
import { getImageDimensions } from '../../cm-upload/utils';
import { ToolbarImage } from '../custom/ToolbarImage';
import { useMarkupToolbarContext } from './context';
const noop = (err) => {
    console.error(err);
};
export const MToolbarImage = ({ focus, onClick, editor, className, }) => {
    const { uploadHandler, needToSetDimensionsForUploadedImages } = useMarkupToolbarContext();
    return (React.createElement(ToolbarImage, { focus: focus, onClick: onClick, className: className, active: false, enable: true, onSubmit: ({ url, name, alt, width, height }) => {
            insertImages(editor.cm, [
                {
                    url,
                    alt,
                    title: name,
                    width: isNumber(width) ? String(width) : '',
                    height: isNumber(height) ? String(height) : '',
                },
            ]);
        }, uploadImages: uploadHandler, onSuccessUpload: async (res) => {
            const images = await toImageItems(res.success, Boolean(needToSetDimensionsForUploadedImages));
            insertImages(editor.cm, images);
        } }));
};
async function toImageItems(items, withDimmensions) {
    const imgItems = [];
    await Promise.all(items.map(({ result, file }) => {
        var _a;
        const imgItem = { url: result.url, alt: (_a = result.name) !== null && _a !== void 0 ? _a : file.name };
        imgItems.push(imgItem);
        if (withDimmensions) {
            return getImageDimensions(file).then(({ height }) => {
                imgItem.height = String(Math.min(height, IMG_MAX_HEIGHT));
            }, noop);
        }
        return Promise.resolve();
    }));
    return imgItems;
}
